import Vue from 'vue';
import { getUrlParam, asyncLoadJs } from '@tencent/magic-ui-util';

const SocketKey = getUrlParam('_socket');
// 测试域名才开启 websocket
const IsTest = /^(a-test)/.test(location.host);
const SocketJs = '//vm.gtimg.cn/comps/ovb-websocket/dist/latest/ovb-websocket.min.js';
type ICallback = (data: any) => void;

/**
 * 实时预览热更新
 */
export async function hotUpdateConfig(callback: ICallback) {
  if (!SocketKey || !IsTest) return;

  await asyncLoadJs(SocketJs, 'anonymous');
  const socket = new window.OvbWebsocket({
    appid: 25,
    send: 'wstest_send',
    isHost: false,
    key: SocketKey,
  });
  socket.on('message', (message: string) => {
    try {
      const { dataKey, data } = JSON.parse(message);
      if (dataKey === 'magicUiconfig') {
        callback(data);
      } else if (dataKey === 'reload') {
        location.reload();
      }
    } catch (error) {
      console.error('格式化错误', message);
    }
  });
  socket.on('connected', () => {
    Vue.prototype.toast('实时预览连接成功');
  });
  socket.on('disconnected', () => {
    Vue.prototype.toast('实时预览编辑器端断开连接');
  });
  socket.on('close', () => {
    Vue.prototype.toast('实时预览本地断开连接');
  });
}
